import { createBrowserHistory } from 'history';

// eslint-disable-next-line import/no-anonymous-default-export
export default createBrowserHistory();
